<template>
  <div class="page-content">
    <!-- 会员档案 -->
    <page-template
      ref="archivesTemplate"
      :tableOptions="tableOptions"
      :searchOptions="searchOptions"
      :toolConfig="toolConfig"
      :addColumns="addColumns"
      :editColumns="editColumns"
      @btnCommon="btnCommon(arguments)"
    ></page-template>
    <el-dialog title="记录" :visible.sync="listShow" width="1400px" height="2000px" :close-on-click-modal="false">
      <list-operation :tableOptions="listColumns" ref="listOperation">
      </list-operation>
    </el-dialog>
    <add-form ref="addFormOptions" @submit="upgradePwd"></add-form>
  </div>
</template>

<script>
import pageTemplate from '@/components/template/pageTemplate';
import listOperation from '@/components/template/listOperation';
import userPower from '@/mixin/userPower'
import api from '@/config/api';
import addForm from "@/components/template/add";

export default {
  mixins: [userPower],
  components: {
    pageTemplate, listOperation, addForm
  },
  data() {
    return {
      listShow: false,
      dialogVisibility: false,
      // 高级搜索条件
      searchOptions: {
        simple: [
          {
            label: "会员姓名/手机号/卡号",
            prop: "phone",
            type: "input",
            span: 12,
            isFuzzy: true,
            placeholder: "请输入会员姓名/手机号/卡号"
          },
        ],
        complex: [
          {
            label: "发卡门店",
            type: "select",
            prop: "cardStoreId",
            span: 8,
            isHasAll: true,
            data: [],
            url: api.system.seStore,
          },
          {
            label: "会员类别",
            prop: "memberCategoryId",
            type: "select",
            span: 8,
            data: [],
            url: api.member.category
          },
          {label: "手机号", prop: "phone", type: "input", span: 8, isFuzzy: true, placeholder: "请输入手机"},
          {label: "卡号", prop: "cardNum", type: "input", span: 8, isFuzzy: true, placeholder: "请输入卡号"},
        ]
      },
      // 更多功能
      toolConfig: [
        {
          label: '新增',
          code: 'insert',
        },
        {
          label: '刷新',
          code: 'refresh',
          filter: () => {
            return false
          }
        },
        {
          label: '批量新增',
          code: 'batchNew',
          filter: () => {
            return false
          }
        },
        {
          label: '下载导入模版',
          code: 'downloadTemplate',
          callback: this.downloadMemberTemplate
        },
        {
          label: '导入',
          code: 'import',
          callback: this.memberImport
        },
        {
          label: '导出',
          code: 'export',
          callback: this.goodsDetailExport,
          filter: () => {
            return false
          }
        },
        {
          label: '积分清零',
          code: 'integralReset',
          callback: this.integralReset,
          filter: () => {
            return false
          }
        },
        {
          label: '编辑',
          type: this.$utils.buttonType.tableOperate,
          code: 'update',
        },
        {
          label: '删除',
          code: 'delete',
          type: this.$utils.buttonType.tableOperate,
          filter: () => {
            return false
          }
        },
        {
          label: '冻结',
          type: this.$utils.buttonType.tableOperate,
          callback: this.freezeCat,
          code: 'freeze',
          filter: () => {
            return false
          }
        },
        {
          label: '挂失',
          type: this.$utils.buttonType.tableOperate,
          callback: this.reportLoss,
          code: 'reportLoss',
          filter: () => {
            return false
          }
        },
        {
          label: '记录',
          type: this.$utils.buttonType.tableOperate,
          callback: this.checkGoods,
          code: 'record',
          filter: () => {
            return false
          }
        },
        {
          label: "修改密码",
          code: "password",
          callback: this.updatePassword
        },
      ],
      // 表格信息配置
      tableOptions: {
        fixed: "right",
        tableName: 'clearTable',
        // showSelect: true,
        indexShow: true,//是否显示索引
        columns: [
          {label: '会员姓名', prop: 'name', width: '120', align: 'left', deal: this.memberName,},
          {label: '卡号', prop: 'cardNum', width: '120', align: 'center'},
          {
            label: '会员类别',
            prop: 'memberCategoryName',
            width: '120',
            align: 'center',
          },
          {
            label: '状态',
            prop: 'status',
            width: '100',
            align: 'center',
            enumData: this.$utils.getCacheStatus('mbMember.status')
          },
          {label: '手机号', prop: 'phone', width: '120', align: 'center'},

          {label: '生日', prop: 'memberBirthday', width: '120', align: 'center'},
          {label: '累计积分', prop: 'cumulativeIntegral', width: '100', align: 'center'},
          {label: '剩余积分', prop: 'usableIntegral', width: '100', align: 'center'},
          {label: '储值余额', prop: 'balanceMoney', width: '100', align: 'center'},
          {label: '积分到期日', prop: 'integralCloseDate', width: '120', align: 'center'},
          // {label: '储值到期日', prop: 'depositCloseDate', width: '120', align: 'center'},
          {label: '发卡门店', prop: 'storeName', width: '120', align: 'center'},
          {label: '创建日期', prop: 'createDttm', width: '190', align: 'center'},

          // {label: '卡号', prop: 'cardNum', width: '120', align: 'center'},
          // {
          //   label: '性别',
          //   prop: 'sex',
          //   width: '120',
          //   align: 'center',
          //   enumData: this.$utils.getCacheStatus("mbMember.sex")
          // },
          // {label: '地址', prop: 'address', width: '200', align: 'center'},
          // {
          //   label: 'plus状态',
          //   prop: 'plusStatus',
          //   width: '100',
          //   align: 'center',
          //   enumData: this.$utils.getCacheStatus('mbMember.plusStatus')
          // },

          // {label: '允许积分', prop: 'generateIntegral', width: '120', align: 'center', type: 'switch'},
          // {label: '允许储值', prop: 'deposit', width: '120', align: 'center', type: 'switch'},

          // {label: '会员有效期', prop: 'memberTerm', width: '120', align: 'center'},
        ],
        // url: api.member.archives,
        param: {storeId: ''},
      },
      editColumns: {
        labelWidth: '120px',
        span: 12,
        columns: [
          {
            label: '手机号',
            type: 'input',
            prop: 'phone',
            maxLength: 11,
            rule: [
              {required: true, message: '请输入手机号', trigger: 'blur'},
              {pattern: this.$utils.reg.phone, message: '请输入正确的手机号', trigger: 'blur'}
            ],
            placeholder: "请输入手机号"
          },
          {
            label: '卡号',
            type: 'input',
            prop: 'cardNum',
            maxLength: 16,
          },
          {
            label: '会员类别',
            type: 'select',
            prop: 'memberCategoryId',
            data: [],
            url: api.member.category,
            // change: this.categoryInfo,
            rule: [{required: true, message: '请选择会员类别'}],
          },
          {
            label: '发卡门店',
            type: 'select',
            prop: 'storeId',
            data: [],
            isHasAll: true,
            url: api.system.seStore,
            rule: [{required: true, message: '请选择发卡门店'}],
          },
          {
            label: '会员姓名',
            type: 'input',
            prop: 'name',
            maxLength: 16,
            rule: [{required: true, message: '请输入会员姓名'}],
            placeholder: "请输入会员姓名"
          },
          {
            label: '性别',
            type: 'select',
            prop: 'sex',
            data: this.$utils.getCacheStatus("mbMember.sex"),
          },
          {
            label: '类型',
            type: 'input',
            prop: 'type',
            defaultValue: 10,
            hidden: true
          },
          {
            label: '累计积分',
            type: 'inputNumber',
            prop: 'cumulativeIntegral',
            disabled: true,
          },
          {
            label: '可使用积分',
            type: 'inputNumber',
            prop: 'usableIntegral',
            disabled: true,
          },
          {
            label: '储值余额',
            type: 'input',
            prop: 'balanceMoney',
            disabled: true,
          },
          {
            label: '积分到期日',
            type: 'datePicker',
            prop: 'integralCloseDate',
            disabled: true,
            rule: [{required: false, message: '请选择积分到期日'}]
          },
          // {
          //   label: '储值到期日',
          //   type: 'datePicker',
          //   prop: 'depositCloseDate',
          //   rule: [{required: false, message: '请选择储值到期日'}]
          // },
          {
            label: '状态',
            type: 'select',
            prop: 'status',
            data: this.$utils.getCacheStatus("mbMember.status"),
          },
          //
          // {
          //   label: '会员有效期',
          //   type: 'datePicker',
          //   prop: 'memberTerm',
          //   rule: [{required: false, message: '请选择会有有效期'}]
          // },
          {
            label: '生日',
            type: 'datePicker',
            prop: 'memberBirthday',

          },
          {
            label: "地址",
            type: "input",
            prop: "address",
            maxLength: 32,
            span: 24,
          },
          {
            label: '备注',
            type: 'textarea',
            prop: 'remarks',
            maxLength: 16,
            isAllline: true
          },
        ],
        url: api.member.archives
      },
      addColumns: {
        labelWidth: '120px',
        span: 12,
        columns: [
          {
            label: '手机号',
            type: 'input',
            prop: 'phone',
            maxLength: 11,
            rule: [
              {required: true, message: '请输入手机号', trigger: 'blur'},
              {pattern: this.$utils.reg.phone, message: '请输入正确的手机号', trigger: 'blur'}
            ],
            placeholder: "请输入手机号",
            change: this.inputPhone
          },
          {
            label: '卡号',
            type: 'input',
            maxLength: 16,
            prop: 'cardNum',
          },
          {
            label: '会员类别',
            type: 'select',
            prop: 'memberCategoryId',
            data: [],
            url: api.member.category,
            // change: this.categoryInfo,
            rule: [{required: true, message: '请选择会员类别'}],
          },
          {
            label: '发卡门店',
            type: 'select',
            prop: 'storeId',
            isHasAll: true,
            data: [],
            url: api.system.seStore,
            // url: api.store.storeList,
            defaultValue: this.$utils.getSysUser().storeId === null ? -1 : this.$utils.getSysUser().storeId,
            rule: [{required: true, message: '请选择发卡门店'}],
          },
          {
            label: '会员姓名',
            type: 'input',
            prop: 'name',
            maxLength: 16,
            rule: [{required: true, message: '请输入会员姓名'}],
            placeholder: "请输入会员姓名"
          },
          {
            label: '性别',
            type: 'select',
            prop: 'sex',
            data: this.$utils.getCacheStatus("mbMember.sex"),
          },
          {
            label: "会员密码",
            type: "password",
            prop: "passwordPlaintext",
            maxLength: 16,
            rule: [
              {required: true, message: "请输入密码", trigger: "blur"},
            ],
          },
          {
            label: '累计积分',
            type: 'inputNumber',
            prop: 'cumulativeIntegral',
            disabled: true,
          },
          {
            label: '可使用积分',
            type: 'inputNumber',
            prop: 'usableIntegral',
            disabled: true,
          },
          {
            label: '储值余额',
            type: 'input',
            prop: 'balance',
            disabled: true,
          },
          {
            label: '类型',
            type: 'input',
            prop: 'type',
            defaultValue: 10,
            hidden: true
          },
          // {
          //   label: '储值到期日',
          //   type: 'datePicker',
          //   prop: 'depositCloseDate',
          //   rule: [{required: false, message: '请选择储值到期日'}]
          // },
          {
            label: '状态',
            type: 'select',
            prop: 'status',
            defaultValue: 10,
            data: this.$utils.getCacheStatus("mbMember.status")
          },
          // {
          //   label: '会员有效期',
          //   type: 'datePicker',
          //   prop: 'memberTerm',
          //   rule: [{required: false, message: '请选择会有有效期'}]
          // },
          {
            label: '生日',
            type: 'datePicker',
            prop: 'memberBirthday',
          },
          // {
          //   label: '地址',
          //   type: 'casaderSelect',
          //   prop: 'province',
          //   span: 24,
          //   // specialRule: [{required: false}],
          //   casaderOptions: [{
          //     prop: 'province',
          //     data: [],
          //     childProps: 'city',
          //     param: {parentId: 0},
          //     url: api.getAreaList,
          //     rule: [{required: false, message: '请选择省！'}]
          //   }, {
          //     prop: 'city',
          //     data: [],
          //     childProps: 'area',
          //     url: api.getAreaList,
          //     rule: [{required: false, message: '请选择市！'}]
          //   }, {
          //     prop: 'area',
          //     data: [],
          //     url: api.getAreaList,
          //     rule: [{required: false, message: '请选择区！'}]
          //   }]
          // },
          {
            label: "地址",
            type: "input",
            prop: "address",
            maxLength: 32,
            span: 24,
          },
          {
            label: '备注',
            type: 'textarea',
            prop: 'remarks',
            maxLength: 16,
            isAllline: true
          },
          // {
          //   label: "经度",
          //   type: "inputNumber",
          //   prop: "longitude",
          //   max: 180,
          //   min: -180,
          //   precision: 5,
          //   rule: [{required: false, message: "请选择区！"}]
          // },
          // {
          //   label: "纬度",
          //   type: "inputNumber",
          //   prop: "latitude",
          //   max: 90,
          //   min: -90,
          //   precision: 5,
          //   rule: [{required: false, message: "请选择区！"}]
          // },
          // {
          //   label: '',
          //   type: 'map',
          //   prop: 'map',
          //   span: 24,
          //   lat: 'latitude',
          //   lon: 'longitude',
          //   labelWidth: 120,
          // },

          // {
          //   label: '积分到期日',
          //   type: 'datePicker',
          //   prop: 'integralCloseDate',
          //   rule: [{required: false, message: '请选择积分到期日'}]
          // },

          // {
          //   label: '卡面卡号',
          //   type: 'input',
          //   prop: 'cardFaceNum',
          // },


        ],
        url: api.member.archives
      },
      //弹出框表格字段
      listColumns: {
        disabled: false,
        indexShow: true,//是否显示索引
        columns:
          [
            {label: '序号', type: 'index', width: 100, prop: 'idx'},
            {
              label: '类型',
              prop: 'type',
              width: '100',
              enumData: this.$utils.getCacheStatus('mbDepositRecord.type')
            },
            {
              label: '充值来源',
              prop: 'sourceType',
              width: '100',
              enumData: this.$utils.getCacheStatus('mbDepositRecord.sourceType')
            },
            {
              label: '设备SN',
              prop: 'sn',
              width: '100',
            },
            {
              label: '购买金额',
              prop: 'depositMoney',
              width: '100',
            },
            {
              label: '赠送金额',
              prop: 'givingMoney',
              width: '100',
            },
            {
              label: '退款金额',
              prop: 'refundMoney',
              width: '100',
            },
            {
              label: '支付方式',
              prop: 'payType',
              width: '100',
              enumData: this.$utils.getCacheStatus("soBillOrder.payType")
            },
            {
              label: '支付时间',
              prop: 'createDttm',
              width: '100',
            },
          ],
      },

      //修改密码
      changePwdDialog: {
        formType: "other",
        labelWidth: "100px",
        span: 12,
        columns: [
          {
            label: "会员名称",
            type: "input",
            prop: "name",
            disabled: true
          },
          {
            label: "新密码",
            type: "password",
            prop: "newPasswordPlaintext",
            rule: [
              {required: true, message: "请输入密码", trigger: "blur"},
              {
                min: 6,
                max: 20,
                message: "长度在6到 20个字符",
                trigger: "blur"
              }
            ]
          },
          {
            label: "确认密码",
            type: "repassword",
            prop: "rePassword",
            passwordProp: "newPasswordPlaintext",
          }
        ],
        url: api.member.archives,
        formData: {},
      },
      settingInfo: {},
    };
  },
  created() {
    // this.setStore(this.searchOptions.complex);
    let user = this.$utils.getSysUser();
    let storeId = this.searchOptions.complex.filter((item) => item.prop === "cardStoreId")[0];
    if (!user.storeId) {//商户身份
      storeId.hidden = false;
    } else {// 门店身份
      if (user.storeClass == 1) {//直营店
        // storeId.defaultValue = user.storeId;
        storeId.hidden = false;
      }
      if (user.storeClass == 2) {//加盟店
        storeId.hidden = true;
      }
    }
    this.setStore(this.addColumns.columns);
    this.getSettingStatus()
    // 会员是商户下全局的，直营门店可以全部查到
    if (this.$utils.getSysUser().storeClass == 1) {
      this.tableOptions.param.storeId = ' '
    }
    this.tableOptions.url = api.member.archives
  },
  mounted() {

  },
  methods: {
    // 会员名称和头像显示
    memberName(row) {
      if (row.headImgUrl !== '--') {
        return '<div style="display: flex;align-items: center">' +
          '<img class="circle-head-img" src="' + row.headImgUrl + '"/>' +
          '<div>' + row.name + '</div>' +
          '</div>'
      } else {
        return '<div>' + row.name + '</div>'
      }
      // let firstName = ''
      // if(row.name){
      //   firstName = row.name.slice(0,1)
      // }
      // return '<div style="display: flex;align-items: center">' +
      //   '<div class="circle-head-phone">'+firstName+'</div>' +
      //   '<div>'+row.name+'</div>' +
      //   '</div>'
    },
    // 获取是 新增 还是 编辑
    btnCommon(val) {
      this.type = val[0].code
      let storeArr = this.editColumns.columns.filter(v => v.prop === 'storeId')//发卡门店
      let phoneArr = this.editColumns.columns.filter(v => v.prop === 'phone')//手机号码
      phoneArr[0].change = false
      // 新增
      if (val[0].code == 'insert') {
        // 发卡时会员卡等于手机号
        if (this.settingInfo.phoneCardCode) {
          phoneArr[0].change = this.inputPhone
        }
      }
      // 编辑
      if (val[0].code == 'update') {
        // 是否允许修改发卡门店
        if (!this.settingInfo.changeCardStore) {
          storeArr[0].disabled = true
        } else {
          storeArr[0].disabled = false
        }
      }
    },
    // 获取设置状态
    getSettingStatus() {
      // 获取设置信息 接口
      this.$axios.fetchGet(api.member.mbMemberDefaultDetail, {}).then(res => {
        if (res.code === 200) {
          if (res.data) {
            this.settingInfo = res.data
          }
        } else {
          this.$message({type: 'error', message: res.msg});
        }
      }).catch(err => {
      })
    },
    // 输入手机号
    inputPhone(val) {
      if (this.type === 'insert' && this.settingInfo.phoneCardCode) {
        // 发卡时会员卡等于手机号
        val.cardNum = val.phone
      }
    },
    integralReset() {
      // 需要同步的数据
      let tableRows = this.$refs.archivesTemplate.getTableSelectRow();
      console.log(tableRows);
      if (tableRows.length === 0) {
        this.$message({message: '请勾选数据后进行积分清零', type: 'warning'});
        return;
      }
      this.$confirm('是否要清零选中会员积分！', "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(() => {
        this.$axios
          .fetchPost(api.member.archives + '/integral/reset', {mbMemberList: tableRows})
          .then(data => {
            if (data.code === 200 && data.data) {
              this.$notify({
                type: "success",
                title: '会员积分清零操作',
                message: '成功',
                showClose: false,
              });
              // this.$message({message: '会员积分清零成功', type: 'success'});
            } else {
              this.$message({message: data.msg, type: 'error'});
            }
          }).catch(err => {
          this.$message({message: '请求失败！', type: 'error'});
        });
      });
    },
    checkGoods(row) {
      this.$axios.fetchPost(api.member.depositRecord + '/list', {memberId: row.id}).then(data => {
        if (data.code === 200) {
          if (data.data.length > 0) {
            this.listShow = true;
            this.$nextTick(() => {
              this.$refs['listOperation'].addMoreRow(data.data, 0);
            });
          } else {
            this.listShow = true;
            this.$refs['listOperation'].clearTableData();
          }
        }
      }).catch(err => {
        console.log(err);
        this.$message({message: "请求失败！", type: "error"});
      })
    },
    freezeCat(form) {
      if (form.status === 10) {
        this.$confirm('您确定想要冻结这个会员？', "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
        }).then(() => {
          //确定的时候执行的代码
          this.$axios.fetchPut(api.member.archives, {id: form.id, status: 60}).then(data => {
            if (data.code === 200) {
              form.status = 60;
              this.$notify({
                type: "success",
                title: '会员冻结操作',
                message: '成功',
                showClose: false,
              });
              // this.$message({type: 'success', message: '会员冻结成功!'});
              this.$emit('success');
            } else {
              this.$message({message: data.msg, type: 'error'});
            }
          })
        })
      } else if (form.status === 20) {
        this.$message({message: '该会员已作废不能进行冻结', type: 'warning'});
      } else if (form.status === 30) {
        this.$message({message: '该会员已挂失不能进行冻结', type: 'warning'});
      } else if (form.status === 40) {
        this.$message({message: '该会员停用不能进行冻结', type: 'warning'});
      } else if (form.status === 50) {
        this.$message({message: '该会员解绑不能进行冻结', type: 'warning'});
      } else {
        this.$message({message: '该会员已冻结无序重复操作', type: 'warning'});
      }
    },
    reportLoss(form) {
      if (form.status === 10 || form.status === 60) {
        this.$confirm('您确定想要挂失这个会员？', "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
        }).then(() => {
          //确定的时候执行的代码
          this.$axios.fetchPut(api.member.archives, {id: form.id, status: 30}).then(data => {
            if (data.code === 200) {
              form.status = 30;
              this.$notify({
                type: "success",
                title: '会员挂失操作',
                message: '成功',
                showClose: false,
              });
              // this.$message({type: 'success', message: '会员挂失成功!'});
              this.$emit('success');
            } else {
              this.$message({message: data.msg, type: 'error'});
            }
          })
        })
      } else if (form.status === 20) {
        this.$message({message: '该会员已作废不能进行冻结', type: 'warning'});
      } else if (form.status === 40) {
        this.$message({message: '该会员停用不能进行冻结', type: 'warning'});
      } else if (form.status === 50) {
        this.$message({message: '该会员解绑不能进行冻结', type: 'warning'});
      } else {
        this.$message({message: '该会员已挂失无序重复操作', type: 'warning'});
      }
    },
    goodsDetailExport() {
      let selectData = this.$refs["archivesTemplate"].$refs["tableTemp"].selectRow;
      this.$axios.fetchPost(api.member.archivesExport, {
        openPlus: selectData.openPlus,
        exportCode: 'MbMemberExport'
      }).then(data => {
        if (data.code === 200) {
          const elink = document.createElement('a');
          elink.href = data.data;
          elink.click();
          this.loadingExt = false;
          this.$notify({
            type: "success",
            title: '导出操作',
            message: '成功',
            showClose: false,
          });
          // this.$message({message: '导出成功', type: 'success'});
        } else {
          this.$notify({
            type: "error",
            title: '导出操作',
            message: '失败',
            showClose: false,
          });
          // this.$message({message: '导出异常', type: 'error'});
        }
      })
    },
    updatePassword(row) {
      this.changePwdDialog.formData = row;
      this.$nextTick(() => {
        this.addColumns && this.$store.commit(this.$utils.storeKeys.OTHERFORM, this.changePwdDialog);
        this.$refs['addFormOptions'].setFormOptions('other', row.id, '密码');
      })
    },
    upgradePwd(data) {
      let params = {id: data.id, newPassword: data.newPassword};
      this.$axios.fetchPost(api.member.archives + "/password" + `?${this.$utils.JSONToString(params)}`, {}).then(result => {
        if (result.code === 200) {
          this.$notify({
            type: "success",
            title: '修改操作',
            message: '成功',
            showClose: false,
          });
          // this.$message({type: 'success', message: '修改成功!'});
        } else {
          this.$message({type: 'error', message: result.msg});
        }
      }).catch(err => {
        this.$notify({
          type: "error",
          title: '修改操作',
          message: '失败',
          showClose: false,
        });
        // this.$message({type: 'error', message: '修改失败!'});
      })
    },

    downloadMemberTemplate() {
      this.$axios.fetchPost(api.member.downloadMemberTemplate, {}).then(data => {
        if (data.code === 200) {
          const elink = document.createElement('a');
          elink.href = data.data;
          elink.click();
          this.loadingExt = false;
          this.$notify({
            type: "success",
            title: '导出操作',
            message: '成功',
            showClose: false,
          });
          // this.$message({message: '导出成功', type: 'success'});
        } else {
          this.$notify({
            type: "error",
            title: '导出操作',
            message: '失败',
            showClose: false,
          });
          // this.$message({message: '导出异常', type: 'error'});
        }
      })
    },
    memberImport() {
      this.$utils.uploadFile((file) => {
        let formData = new FormData();
        formData.append('multipartFile', file);
        const loading = this.$loading({
          lock: true,
          text: '正在导入...',
          background: 'rgba(225, 225, 225, 0.8)'
        });
        this.$axios
          .fetchPostGoodsExportBlob(api.member.importMember, formData)
          .then(data => {
            if (data.status === 200) {
              if (data.data.byteLength === 0) {
                // this.$message({message: "导入成功", type: "success"});
                this.$notify({
                  type: "success",
                  title: '导入操作',
                  message: '成功',
                  showClose: false,
                });
                this.$refs['archivesTemplate'].operationSuccess();
              } else {
                this.$confirm('下载错误数据!确认？')
                  .then(_ => {
                    this.$refs['archivesTemplate'].operationSuccess();
                    this.exportErrorData(data);
                  })
                  .catch(() => {
                    this.$refs['archivesTemplate'].operationSuccess();
                  })
              }
            } else {
              this.$notify({
                type: "error",
                title: '导入操作',
                message: '失败',
                showClose: false,
              });
              // this.$message({message: '会员导入异常', type: 'error'});
            }
          }).catch(() => {
          loading.close();
          this.$notify({
            type: "error",
            title: '导入操作',
            message: '失败',
            showClose: false,
          });
        }).finally(() => {
          loading.close();
        });
      })
    },
    exportErrorData(data) {
      // const elink = document.createElement('a');
      // elink.href = data.data;
      // elink.click();
      // this.loadingExt = false;
      // this.$notify({
      //   type: "success",
      //   title: '导出操作',
      //   message: '错误会员导出成功',
      //   showClose: false,
      // });
      // this.$message({message: '错误会员导出成功', type: 'success'});

      const fileName = '导入会员错误数据' + '_' + this.$utils.getDateTime() + ".xlsx";
      let blob = new Blob([data.data]);
      let downloadElement = document.createElement('a');
      let href = window.URL.createObjectURL(blob); //创建下载的链接
      downloadElement.href = href;
      downloadElement.download = fileName; //下载后文件名
      document.body.appendChild(downloadElement);
      downloadElement.click(); //点击下载
      document.body.removeChild(downloadElement); //下载完成移除元素
      window.URL.revokeObjectURL(href); //释放掉blob对象
      this.$notify({
        type: "success",
        title: '导出操作',
        message: '成功!文件名称:' + fileName,
        showClose: false,
      });
    },
  }
};
</script>




// WEBPACK FOOTER //
// src/page/member/Archives.vue